import React, { createContext, useState, useContext } from 'react';

const PermissionContext = createContext();
export const usePermission = () => {
  return useContext(PermissionContext);
};

export const PermissionProvider = ({ children }) => {
  const [checkAccess, setCheckAccess] = useState(null);
  
  return (
    <PermissionContext.Provider value={{ checkAccess, setCheckAccess }}>
      {children}
    </PermissionContext.Provider>
  );
};

